import { Component, OnInit } from '@angular/core';
import { SecureStorageService } from '@ig-core/authentication/secureStorage.service';
import { ReferenceCodeService } from './reference-code/reference-code.service';

@Component({
  selector: 'eng-admin',
  templateUrl: './admin.template.html',
  styleUrls: ['./admin.styles.scss'],
})
export class AdminComponent implements OnInit {

  selectedMenu: string = '';
  loginUser: any;

  constructor(public secureStorageService: SecureStorageService,
    private referenceCodeService: ReferenceCodeService
  ) {
  }

  ngOnInit(): void {
    this.loginUser = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails")
  }

  updateSelectedMenu(selectedMenu) {
    this.selectedMenu = selectedMenu;
  }

}